

import Vue from "vue"
import Icon from '@/components/svgIcon/index.vue'
import { mapGetters } from 'vuex'
import { faBars, faExpand, faLanguage, faPalette, faUser } from '@fortawesome/free-solid-svg-icons'
import { faThemeisle } from '@fortawesome/free-brands-svg-icons'
import SVGIcon from '@/components/svgIcon/index.vue'
import Tooltip from '@/components/tooltip/index.vue'
import { ETrigger, EDirection } from '@/components/tooltip/prop'
import useFullScreen from '@/hooks/useFullScreen'
import useMessage from "@/hooks/useMessage"
import { ELoginStatus } from '@/store/user'
import { ELanguageType } from "@/plugins/i18n"
import { changeLanguage } from "@/hooks/useChangeLanguage"
const { showMessage } = useMessage()


const { setFullScreen, offFullScreen } = useFullScreen()

export default Vue.extend({


	beforeDestroy() {
		offFullScreen()
	},
	components: {
		Icon,
		SVGIcon,
		Tooltip
	},
	methods: {
		changeMenuShow() {
			if (this.showMenu) {
				this.$store.dispatch(`menuStore/closeMenu`)
			} else {
				this.$store.dispatch(`menuStore/openMenu`)
			}

		},
		changeTheme(item: string, e: Event) {
			if (this.currentTheme !== item) {
				this.$store.dispatch(`themeStore/changeTheme`, item)
			}
			e.stopPropagation()
		},
		showFullScreen() {

			const dom = document.querySelector(".layout-conter-cneter")
			setFullScreen(dom as any)

		},

		handlerLoginOut() {
			if (this.isLogined) {
				this.$store.dispatch("userStore/logout")
			} else {
				this.$router.push({
					name: 'login'
				})
			}
		},
		changeLanguage,
	},
	computed: {
		...mapGetters({
			showMenu: 'menuStore/showMenu',
			currentRoute: 'routeStore/currentRoute',
			currentTheme: "themeStore/theme",
			allTheme: "themeStore/allTheme",
			loginStatus: "userStore/loginStatus"
		}),
		menuIcon: () => faBars,
		fullScreen: () => faExpand,
		user: () => faUser,
		language() {
			return {
				icon: faLanguage,
				trigger: ETrigger.click,
				items: (Object.keys(ELanguageType) as TLanguages[]).map(type => ({ type, label: ELanguageType[type] })),

			}
		},
		theme(): any {
			return {
				icon: faPalette	,
				trigger: ETrigger.click,
				items: Reflect.ownKeys(this.allTheme)
			}
		},
		isLogined(): boolean {
			return this.loginStatus === ELoginStatus.logined
		},





	}
})
